import React from "react";

const TestSecretPage = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Internal Test Page</h2>

      <img
        src="https://www.ansell.com/-/media/projects/ansell/website/pim/product-assets/hyflex/hyflex-11-618/hyflex-11-618_emea_white.ashx?rev=33447a30563448dabfaadc97d14747b1&mh=872&la=en&mw=450&hash=9B7C614001BFA0C2104993B54BCC6FCB"
        alt="test"
        style={{ maxWidth: "300px" }}
      />
    </div>
  );
};

export default TestSecretPage;

